import { createReducer, on } from "@ngrx/store";
import { updateState } from "@obg/ngx.global";

import { SessionSummaryAction } from "./session-summary.action";
import { SessionSummaryState } from "./session-summary.model";

const INITIAL_STATE: SessionSummaryState = {
	sessionSummary: undefined,
};

export const sessionSummaryReducer = createReducer(
	INITIAL_STATE,
	on(SessionSummaryAction.clear, (state) => updateState(state, { sessionSummary: undefined })),
	on(SessionSummaryAction.fetchBeforeLogoutSuccess, (state, { sessionSummary }) =>
		updateState(state, { sessionSummary })
	),
	on(SessionSummaryAction.fetchSuccess, (state, { sessionSummary }) => updateState(state, { sessionSummary }))
);
